"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const constants_1 = require("./constants");
/**
 * @deprecated Use buildEarnKey instead
 * @param offerId - The offerId to use for the request
 * @param isWithinRenewalGracePeriod - Whether the customer is within the renewal grace period (available from svc-membership)
 * @param promoId - The promoId to use for the request
 * @returns magic earn key used for the LuxPlus+ renewal bonus request if the customer is within the renewal grace period
 */
function buildLuxPlusBonusRequestEarnKey(offerId, isWithinRenewalGracePeriod, promoId) {
    if (!isWithinRenewalGracePeriod)
        return '';
    const keys = [constants_1.LUX_LOYALTY_LUX_PLUS_ELIGIBLE_RENEWAL_BONUS_ID, offerId];
    if (promoId)
        keys.push(promoId);
    return keys.join(':');
}
exports.default = buildLuxPlusBonusRequestEarnKey;
